module.exports = __webpack_public_path__ + "img/20_76.f8dae74b.png";